<template>
  <div>
    <breadcrumbPage></breadcrumbPage>
    <div class="content EC_width">
      <div class="leftContent">
        <div class="title">
          <span>{{newInfo.title}}</span>
        </div>
        <div class="display_between"
             style="border-bottom: 1px solid #ddd;">
          <div class="showInfo">
            <span class="split">
              <img src="/image/icon/shizhong.png">
              {{ formatTime(newInfo.publishtime, 'YYYY/MM/DD') }}
            </span>
            <span class="split">
              {{newInfo.source}}
            </span>
            <span class="split">
              {{newInfo.clickVolume}}
            </span>
          </div>
          <div>
            <span class="gree_block"
                  v-for="(item,index) in (newInfo.labelName || '').split(',')"
                  :key="'0'+index">{{item}}</span>
          </div>
        </div>

        <div class="mainTextWrap">
          <!-- <p :class="{mainText:item.sign=='mainText',maintitle:item.sign=='maintitle',mainImg:item.sign=='mainImg'}" v-for="(item,index) in apiData.article.data.content" :key="'0'+index">
                        <img :src="item.main" v-if="item.sign=='mainImg'">
                        <span v-if="item.sign!='mainImg'">{{item.main}}</span>
                    </p> -->
          <p v-html="newInfo.contents"></p>
          <div class="downInfor marginBottom10">
            <p>{{newInfo.disclaimer}}</p>
          </div>
        </div>
        <div class="timeLine">
          <div class="flex1 display_between">
            <div class="display_center tipsHover"
                 v-if="lastNew.title!=''">
              <div class="page_btn"
                   style="margin-right: 10px;">
                &lt;
              </div>
              <div @click="clkNew(lastNew)">
                <a href="javascript:;"
                   class="page_btn_active_link"><span style="font-weight: bold;">上一篇：</span>
                  {{ellipsis(lastNew.title,18)}}</a>
              </div>
            </div>
            <div class="display_center tipsHover"
                 v-if="nextNew.title!=''">
              <div @click="clkNew(nextNew)">
                <a class="page_btn_active_link"
                   href="javascript:;"><span style="font-weight: bold;">下一篇：</span>
                  {{ellipsis(nextNew.title,18)}}
                </a>
              </div>
              <div class="page_btn page_btn_active"
                   style="margin-left: 10px;">
                &gt;
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rightVideoList">
        <div class="rightVedioTitle display_between marginBottom20">
          <div class="leftTitle">更多专题</div>
          <div>
            <!-- <a href="javascript:;"><img src="/image/index/moreimg.png" class="marginRight5">更多</a> -->
          </div>
        </div>
        <div class="videoWrap marginBottom30"
             v-for="(item,index) in speciRecommeData"
             :key="'0'+index"
             @click="clickSpecial(item)">
          <!-- <video src="" controls="controls">
                        当前浏览器不支持 video直接播放，点击这里下载视频： <a href="myvideo.webm">下载视频</a>
                    </video> -->
          <img :src="item.slideShow"
               width="285"
               height="169"
               class="imgtran">
          <div class="videoTitle">
            {{item.title}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumbPage from '../home/breadcrumbPage'
import format from '@/assets/unit/unit.js';
export default {
  name: 'specialDetails',
  data () {
    return {
      apiData: {
        article: {},
        course: {},
      },
      /**tianlianpei */
      newInfo: {},
      contents: '',
      lastNew: {
        id: 0,
        title: '',
      },
      nextNew: {
        id: 0,
        title: '',
      },
      column_Type: 0,
      c_name: '',
      p_name: '', //父名称
      parentid: 0,
      speciRecommeData: [],
    }
  },
  methods: {
    formatTime (datatime, timeformat) {
      return format(datatime, timeformat);
    },
    getData () {
      var that = this
      fetch('/data.json')
        .then((res) => {
          return res.json()
        })
        .then((data) => {
          that.apiData = data.specialDetails.data
        })
    },
    /**tianlianpei */
    //根据新闻ID获取新闻详情
    GetNewInfoById (id, column_Type) {
      let _this = this
      _this.httphelper
        .post('/api/NewApi/GetNewInfoById', {
          keyword: '',
          id: parseInt(id),
          parentID: 0,
          column_Type: parseInt(column_Type),
          pageIndex: 0,
          pageSize: 0,
        })
        .then((res) => {
          if (res.data.code == 200) {
            let newinfolist = res.data.data.gpSiteNewInfoViewsViews
            if (newinfolist != null && newinfolist.length > 0) {
              _this.newInfo = newinfolist[0]
              _this.contents = _this.newInfo.contents
            }
            _this.lastNew = res.data.data.lastNextPieceNewViews[0]
            _this.nextNew = res.data.data.lastNextPieceNewViews[1]
          }
        })
    },
    clkNew (e) {
      this.$router.push({
        path: '/home/specialDetails',
        query: {
          id: e.id,
          column_Type: this.column_Type,
        },
      })
      window.location.reload()
    },
    GetColumsInfoAllList () {
      let _this = this
      _this.httphelper
        .post('/api/NewApi/GetColumsInfoAllList', {
          cType: 2,
          isCHorEN: 1,
        })
        .then((res) => {
          if (res.data.code == 200) {
            let data = []
            data = res.data.data
            let obj = {}
            obj = data.find((item) => {
              return item.id === _this.column_Type
            })
            //二级菜单
            _this.c_name = obj.name
            _this.parentid = obj.parentid
            //一级菜单
            _this.p_name = data.find((item) => {
              return item.id === obj.parentid
            }).name
          }
        })
    },
    //获取首页专题，全科病例数据
    getSpecilCaseList () {
      let _this = this
      _this.httphelper
        .post('/api/NewApi/GetGpSiteNewInfoPageList', {
          keyword: '',
          id: 0,
          parentID: 0,
          column_Type: 47,
          pageIndex: 1,
          pageSize: 4,
        })
        .then((res) => {
          res.data.data.gpSiteNewInfoViewsViews.forEach((item) => {
            if (item.cid == 47) {
              _this.speciRecommeData.push(item)
            }
          })
        })
    },
    clickSpecial (info) {
      let urlstr = info.address
      let param = urlstr.substr(
        urlstr.indexOf('?'),
        urlstr.length - urlstr.indexOf('?')
      )
      if (urlstr.search('specialRecomme') > -1) {
        const { href } = this.$router.resolve({
          path: '/home/specialRecomme' + param,
        })
        window.open(href, '_blank')
      } else if (urlstr.search('specialproject') > -1) {
        const { href } = this.$router.resolve({
          path: '/enterprise/qyhome' + param,
        })
        window.open(href, '_blank')
      } else {
        window.open(info.address, '_blank')
      }
    },
  },
  created () {
    this.getData()
    this.column_Type = parseInt(this.$route.query.column_Type)
    this.GetNewInfoById(this.$route.query.id, this.$route.query.column_Type)
    this.GetColumsInfoAllList()
    this.getSpecilCaseList()
  },
  components: {
    breadcrumbPage,
  },
}
</script>

<style scoped>
.content {
    padding-top: 30px;
    display: flex;
    flex: 1;
}
.leftContent {
    flex: 1;
}
.title {
    font-size: 26px;
    font-weight: bold;
    margin-bottom: 30px;
}
.title span {
    padding: 0 20px;
    border-left: 4px solid #0b8686;
}
.showInfo {
    height: 54px;

    line-height: 54px;
}
.split {
    font-size: 14px;
    position: relative;
    margin-right: 20px;
}
.mainTextWrap {
    padding-top: 30px;
    border-bottom: 1px solid #ddd;
}
.maintitle {
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 15px;
}
.mainText {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 32px;
    margin-bottom: 44px;
}
.mainImg {
    margin-bottom: 44px;
}
.downInfor {
    color: #ccc;
}
.gree_block,
.red_block,
.blue_block {
    display: inline-block;
    padding: 4px 8px;
    font-size: 12px;
    margin-right: 5px;
}

.gree_block {
    border: 1px solid #469a97;
    color: #469a97;
}

.red_block {
    border: 1px solid #cc6d6e;
    color: #cc6d6e;
}

.blue_block {
    border: 1px solid #417393;
    color: #417393;
}
.timeLine {
    height: 80px;
    line-height: 80px;
}
.page_btn {
    color: #999;
    cursor: pointer;
    display: inline-block;
    width: 22px;
    height: 22px;
    text-align: center;
    line-height: 22px;
    border-radius: 22px;
    border: 1px solid #ccc;
}

/* 右侧样式设置 */
.rightVideoList {
    width: 310px;
    margin-left: 50px;
}
/* 右面视频列表样式 */

.rightVedioTitle {
    height: 56px;
    line-height: 56px;
    border-bottom: 1px solid #ddd;
}
.leftTitle {
    font-size: 20px;
    font-weight: bold;
    border-bottom: 1px solid #333;
}
.videoWrap video {
    width: 100%;
}
.videoTitle {
    font-size: 16px;
    margin-top: 12px;
}
.tipsHover:hover .page_btn_active_link {
    color: #0b8686;
}
.tipsHover:hover .page_btn {
    background: #0b8686;
    color: #fff;
    border: 1px solid #0b8686;
}
</style>
